import classnames from 'classnames';
import * as propTypes from 'prop-types';
import * as React from 'react';
import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
interface IState {
    collapsed: boolean;
    childHeight: string;
}

interface IProps {
    title: JSX.Element;
    icon?: JSX.Element;
    onClick?: () => void;
    wrapperStyle?: React.CSSProperties;
    containerStyle?: React.CSSProperties;
    titleStyle?: React.CSSProperties;
    childStyle?: React.CSSProperties;
    arrowStyle?: React.CSSProperties;
    heightAnimationRequired?: boolean;
    lazyLoadChild?: JSX.Element;
    isNested?: boolean; // Avoid double tracking of nested components
    isCollapsed?: boolean;
    setCollapsed?: Function;
    compName?: string;
    refs?: any;
}

export class CollapsibleDropDown extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            collapsed: props.isCollapsed != undefined ? props.isCollapsed : true,
            childHeight: 'auto',
        };
    }

    static contextTypes = {
        track: propTypes.func,
    };

    childRef = this.props.refs ? this.props.refs : null;
    getChildRef = (ref) => (this.childRef = ref);
    calculateChildHeight = () => {
        this.setState({
            //40 pixels added considering the margin-top and margin-bottom as 20px each
            childHeight: this.childRef.clientHeight + 40,
        });
    };

    componentDidMount() {
        if (this.props.heightAnimationRequired) {
            this.calculateChildHeight();
            window.addEventListener('resize', this.calculateChildHeight);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.calculateChildHeight);
    }

    collapseButtonHandler = () => {
        if (this.props.onClick) {
            this.props.onClick();
        }
        if (this.props.setCollapsed) {
            this.props.setCollapsed(!this.state.collapsed, this.props.compName, this.childRef);
        }
        this.setState({ collapsed: !this.state.collapsed });
        if (this.context.track && this.state.collapsed && !this.props.isNested) {
            this.context.track();
        }
    };

    getChildren = () => {
        if (!this.props.lazyLoadChild) {
            return this.props.children;
        }
        if (this.state.collapsed) {
            return this.props.children;
        } else {
            return this.props.lazyLoadChild;
        }
    };

    render() {
        const {
            title,
            icon,
            wrapperStyle,
            containerStyle,
            titleStyle,
            arrowStyle,
            childStyle,
        } = this.props;
        const iconClasses = classnames('collapsibleSectionIcon', { rotate: !this.state.collapsed });

        const calculatedChildHeight =
            !this.state.collapsed && this.childRef
                ? this.props.heightAnimationRequired
                    ? this.state.childHeight
                    : 'auto'
                : 0;
        const childHeight: React.CSSProperties = {
            overflow: this.state.collapsed ? 'hidden' : 'visible',
            height: calculatedChildHeight,
        };
        return (
            <div style={{ ...wrapperStyle }} className="collapsibleSection">
                <div
                    className="collapsibleSectionHeader"
                    style={{ ...containerStyle }}
                    onClick={this.collapseButtonHandler}
                >
                    <div className="titleSection" style={{ ...titleStyle }}>
                        {icon}
                        {title}
                    </div>
                    <div style={{ ...arrowStyle }} className={iconClasses}>
                        <ArrowDownIcon width={20} height={20} />
                    </div>
                </div>
                <div style={childHeight} className="collapsibleSectionContent">
                    <div ref={this.getChildRef} style={{ ...childStyle }}>
                        {this.getChildren()}
                    </div>
                </div>
            </div>
        );
    }
}
